import Table, { TableProps } from 'rc-table';
import { DefaultRecordType } from 'rc-table/lib/interface';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { NoRecordTable } from 'src/components/core/icons';
import { FlexContainer } from 'src/components/core/layout/FlexContainer';
import { useAuth } from 'src/context/AuthContext';

const StyledRCTable = styled(Table)`
    ${({ theme: { colors, typography } }) => `
    min-width: 1100px;
    & .detail-table { 
        tr:not(.rc-table-measure-row) {
            height: 20px !important;
        }   
    }
    .rc-table-content {
        table {
            width: 100%;
            padding-left: 20px;
        }
    }
    .rc-table-cell {
        font-size: ${typography.size.desktop.paragraph.p3};
        font-weight: ${typography.weight.normal};
        line-height: calc(${typography.lineHeight[2]} - 1px);
        text-align: left;
        padding: 0;
        cellspacing: 17px;
         white-space: nowrap;
    }
    .centerText {
        text-align: center;
    }
    .rc-table-thead {
        tr {
            height: 40px;
            padding: 12px 26px;
            width: 100%;
             white-space: nowrap;
            .rc-table-cell {
                color: ${colors.text.tertiary};
                 white-space: nowrap;
            }
        }
    }
    .rc-table-tbody {
        min-height: 250px;
        tr {
            height: 43px;
             white-space: nowrap;
        }
        .rc-table-cell {
            color: ${colors.text.primary};
            white-space: nowrap;
        }
        .contract {
            &.borderGreen {
                border-left: 2px solid ${colors.alert.green};
            }
            &.borderRed {
                border-left: 2px solid ${colors.alert.red};
            }
            padding-left: 7px;
            .symbol-name {
                span {
                    color: ${colors.text.tertiary};
                }
            }
            .leverage {
                font-size: 10px;
                font-weight: ${typography.weight.normal};
                line-height: calc(${typography.lineHeight[2]} - 1px);
                color: ${colors.alert.yellow};
            }
        }
        .greenText {
            color: ${colors.alert.green};
        }
        .yelloText {
            color: ${colors.alert.yellow};
        }
        .redText {
            color: ${colors.alert.red};
        }
        .greyText {
            color: ${colors.text.tertiary};
        }
        .action-button {
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            font-weight: ${typography.weight.medium};
            color: ${colors.text.tertiary};
            border: 0.6px solid ${colors.text.tertiary};
            border-radius: 3px;
            padding: 2px 4px;
        }
        .rc-table-expanded-row-fixed {
            width: 100% !important;
             white-space: nowrap;
        }
        .rc-table-cell-fix-left {
            background-color: ${colors.background.primary};
             white-space: nowrap;
        }
    }
`}
`;
const RCTableWrapper = styled.div`
    width: 100%;
    min-height: 300px;
    &.detail-table {
        padding: 0 8px;
        min-height: 60px;
    }
    overflow-x: auto;
`;

const StyledTable: FC<DefaultRecordType> = (props: TableProps<DefaultRecordType>) => {
    const { t } = useTranslation();
    const { colors } = useTheme();

    const { isAuthenticated } = useAuth();

    const tableProps = {
        style: { width: '100%' },
        scroll: { x: '100%', y: 'calc(100vh - 55vh - 90px)' },
        emptyText: (
            <>
                {isAuthenticated ? (
                    <FlexContainer
                        styles={{
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '210px',
                            maxHeight: '210px',
                            width: '100%',
                        }}
                        className="no-record"
                    >
                        <NoRecordTable
                            fill={colors.background.primary}
                            stroke={colors.border.dark}
                        />
                        <p>{t('no_record')}</p>
                    </FlexContainer>
                ) : (
                    <FlexContainer
                        styles={{
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '210px',
                            maxHeight: '210px',
                            width: '100%',
                        }}
                        className="logout-user-message"
                    >
                        <p>
                            {t('please')} <a href="/login">{t('login')}</a> {t('or')}{' '}
                            <a href="/register">{t('signup')}</a> {t('first')}
                        </p>
                    </FlexContainer>
                )}
            </>
        ),
        ...props,
    };
    return (
        <RCTableWrapper className={props.className}>
            <StyledRCTable {...tableProps} />
        </RCTableWrapper>
    );
};
export { StyledTable };
